module.exports = __webpack_public_path__ + "img/PRCA1_pDC.86382c92.png";